module.exports = __webpack_public_path__ + "media/src/images/balloons/womans_day_headline_en-62c1835335303073e85db2d57c871261.png";